export default "__VITE_ASSET__BGG5GbZ6__"